import MedicalSerializer from './base';

export default class Batch extends MedicalSerializer {
  normalize(model, hash, prop) {
    let defaults = {
      quantity: 0,
      deleted: false,
    };
    Object.assign(defaults, hash);
    hash = defaults;
    return super.normalize(model, hash, prop);
  }
}
